<template>
  <div>
    <vx-card class="mt-2">
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="mb-4">
            <div class="flex flex-wrap items-center">
              <p class="card-sub-title mr-5">
                Sobre ti. (Obligatorio para invertir)
              </p>
            </div>
          </div>
          <p>
            Una vez completada tu verificación de identidad podrás consultar en esta sección tus datos y documentación general.
            <span class="bold">Completa este apartado antes de comenzar a invertir, ya que de lo contrario no podrás continuar participando en la Red.</span>
          </p>
        </div>
      </div>
      <div class="vx-row mt-3" >
        <div class="vx-col w-full">
          <vs-button class="ml-auto mt-2" @click.stop="goToAboutYou">Ver</vs-button>
        </div>
      </div>
    </vx-card>

    <vx-card class="mt-5">
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="mb-4">
            <div class="flex flex-wrap items-center">
              <p class="card-sub-title mr-5">
                Contacto. (Recomendado)
              </p>
            </div>
          </div>
          <p>
            En esta sección se encuentran datos importantes sobre tu ubicación, domicilio, teléfono celular, entre otros.
            Procura mantener este apartado lo más actualizado posible.
            <span class="bold">Por el momento esta sección no es obligatoria para invertir o retirar.</span>
          </p>
        </div>
      </div>
      <div class="vx-row mt-3" >
        <div class="vx-col w-full">
          <vs-button class="ml-auto mt-2" @click.stop="goToContact">Ver</vs-button>
        </div>
      </div>
    </vx-card>

    <vx-card class="mt-5">
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="mb-4">
            <div class="flex flex-wrap items-center">
              <p class="card-sub-title mr-5">
                Banco. (Obligatorio para retirar)
              </p>
            </div>
          </div>
          <p>
            Agrega, consulta o administra las cuentas de banco con las que deseas participar en la Red.
            Puedes tener tantas cuentas sean necesarias, pero considera que necesitas tener al menos una cuenta verificada para
            poder operar dentro de RedGirasol con la que podrás retirar los fondos de tu saldo disponible en el momento en que lo necesites.
          </p>
        </div>
      </div>
      <div class="vx-row mt-3" >
        <div class="vx-col w-full">
          <vs-button class="ml-auto mt-2" @click.stop="goToBank">Ver</vs-button>
        </div>
      </div>
    </vx-card>

    <vx-card class="mt-5">
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="mb-4">
            <div class="flex flex-wrap items-center">
              <p class="card-sub-title mr-5">
                Beneficiarios. (Recomendado)
              </p>
            </div>
          </div>
          <p>
            ¿Quiénes son tus beneficiarios? Consulta y administra los datos e información más relevante de tus beneficiarios.
            Procura mantener este apartado lo más actualizado posible.
            <span class="bold">Por el momento esta sección no es obligatoria para invertir o retirar.</span>
          </p>
        </div>
      </div>
      <div class="vx-row mt-3" >
        <div class="vx-col w-full">
          <vs-button class="ml-auto mt-2" @click.stop="goToBeneficiaries">Ver</vs-button>
        </div>
      </div>
    </vx-card>

    <vx-card class="mt-5">
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="mb-4">
            <div class="flex flex-wrap items-center">
              <p class="card-sub-title mr-5">
                Perfil fiscal.
              </p>
            </div>
          </div>
          <p>
            Es importante que registres tus datos fiscales (RFC, Nombre, Código Postal y régimen).
          </p>
        </div>
      </div>
      <div class="vx-row mt-3" >
        <div class="vx-col w-full">
          <vs-button class="ml-auto mt-2" @click.stop="goToTaxProfile">Ver</vs-button>
        </div>
      </div>
    </vx-card>

  </div>
</template>

<script>

export default {
  name: "InvestorProfileV3",
  props: {
    InvestorId: {
      type: [String,Number],
      required: true
    }
  },
  data() {
    return {
      isMounted: false,
      identity: null,
      status: null,
      processWasStarted: false,
    }
  },
  mounted(){
    this.isMounted = true
  },
  computed: {
    shouldRunMatiProcess(){
      return this.status === 0 || this.status === 4 ||this.status === 5;
    },
    verificationIsCompleted(){
      return this.status === 1;
    },
    verificationIsRejected(){
      return this.status === 4;
    },
    verificationIsInProcess(){
      return  this.status === 3;
    },
    verificationisNewRequired(){
      return this.status === 5;
    },
    verificationIsReviewNeeded(){
      return this.status === 2;
    },
  },
  methods: {
    async reloadStatus(){
      this.showLoading(true)
      this.processWasStarted = false;
      this.showLoading(false)
    },
    async onMatiProcessStarted(){
      this.$store.commit("TOGGLE_IS_MATI_POPUP_ACTIVE", false);
      this.processWasStarted = true;
    },
    async goToAboutYou(){
      await this.$router.push({name: 'perfilInversionistaAbout'});
    },
    async goToContact(){
      await this.$router.push({name: 'perfilInversionistaContact'});
    },
    async goToBank(){
      await this.$router.push({name: 'perfilInversionistaBank'});
    },
    async goToBeneficiaries(){
      await this.$router.push({name: 'perfilInversionistaBeneficiaries'});
    },
    async goToTaxProfile(){
      await this.$router.push({name: 'investorTaxProfile'});
    },
    async goToEditProfile(){
      await this.$router.push({name: 'perfilInversionistaGeneral'});
    },
    async goToKycPage(){
      await this.$router.push({name: 'kycInversionista'});
    },
    async openMatiPopup(){
      this.$store.commit("TOGGLE_IS_MATI_POPUP_ACTIVE", true);
    },
  }
}
</script>

<style scoped>
.card-disabled{
  opacity: 0.4;
}
</style>